import { create } from "zustand";

const ErrorStore = create((set) => ({
  isOpen: false,
  message: "",

  showError: (message) =>
    set({
      isOpen: true,
      message,
    }),

  closeError: () =>
    set({
      isOpen: false,
      message: "",
    }),
}));

export default ErrorStore;